import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmRepModal = ({ show, handleClose, handleConfirm }) => {
  return (
    <Modal show={show} onHide={handleClose} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Reset Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Contact data has been added. Are you sure you want to reset it?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Reset
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmRepModal;
